import React from "react";
import "./index.scss";

const cloudImages = [
  "https://i.ibb.co/HrWcHqL/clouda6.png",
  "https://i.ibb.co/jThXncF/clouda2.png",
  "https://i.ibb.co/hmPBGGh/clouda3.png",
  "https://i.ibb.co/YBwsL7S/clouda4.png",
  "https://i.ibb.co/K7jNJPr/clouda5.png",
];

const FloatingClouds = () => {
  return (
    <div className="Clouds">
       
          {cloudImages.map((image, index) => (
            <div
              key={index}
              className={`Clouds__div__imageContainer__imagediv cloud-${index}`}
            >
              <img
                className="Clouds__div__imageContainer__imagediv__image"
                src={image}
                alt={`cloud-${index}`}
              />
            </div>
          ))}
  
    </div>
  );
};

export default FloatingClouds;
